import axios from "@/utils/request"

export const loadAll = (params) => {
  return axios.request({
    url: "zhuan_ti/list",
    method: "GET",
    params,
  });
};
